<script>
import { mapGetters } from "vuex";

import { Btn, BtnGroup, Affix } from "uiv";

import GoTopButton from "vue-go-top-button";

import Barra from "./Barra.vue";
import Total from "./Total.vue";
import Buscador from "./Buscador.vue";
import Preloader from "./Preloader.vue";
import PreloaderFicha from "./PreloaderFicha.vue";

/** Filtros */
import FiltroAdmin from "./Filtros/Admin.vue";
import FiltroClear from "./Filtros/Clear.vue";
import FiltroTexto from "./Filtros/Texto.vue";
import FiltroPrecio from "./Filtros/Precio.vue";
import FiltroDuracion from "./Filtros/Duracion.vue";
import FiltroSalidas from "./Filtros/Salidas.vue";
import FiltroDestinos from "./Filtros/Destinos.vue";
import FiltroProveedores from "./Filtros/Proveedores.vue";

import Proveedores from "./Proveedores.vue";

export default {
  props: {
    url: { type: String, required: true },
    conectores: { type: Array, required: true },

    isFormas: { type: Boolean, default: false },

    isDev: { type: Boolean, default: false },
    isPow: { type: Boolean, default: false },
    isAdmin: { type: Boolean, default: false },
    showConectores: { type: Boolean, default: false },

    codigo: { type: String, default: "" },
    conector: { type: String, default: "" },

    monedaDefecto: { type: String, default: "" },
    ordenTarifa: { type: Boolean, default: false },
    tarifaConector: { type: Boolean, default: false },

    preloaderUrl: { type: String, required: true },
    params: {
      mes_salida: { type: String, required: false },
      ciudad_salida: { type: String, required: false },
      ciudades: {
        type: Array,
        required: false,
        default() {
          return [];
        },
      },
      proveedores: {
        type: Array,
        required: false,
        default() {
          return [];
        },
      },
    },
  },
  components: {
    Btn,
    Affix,
    BtnGroup,

    Barra,
    Total,
    Buscador,
    Preloader,
    Proveedores,
    PreloaderFicha,

    GoTopButton,

    /** Filtros */
    FiltroAdmin,
    FiltroClear,
    FiltroTexto,
    FiltroPrecio,
    FiltroDuracion,
    FiltroSalidas,
    FiltroDestinos,
    FiltroProveedores,
  },
  data() {
    return {
      showFiltros: null,
      showBuscador: null,
      filtrosWidth: "100%",
    };
  },
  created() {
    this.$store.commit("setURL", this.url);

    this.$store.commit("setDev", this.isDev);
    this.$store.commit("setPow", this.isPow);
    this.$store.commit("setAdmin", this.isAdmin);
    this.$store.commit("setShowConectores", this.showConectores);

    this.$store.commit("setFormas", this.isFormas);
    this.$store.commit("setConectores", this.conectores);
    this.$store.commit("setPreloaderUrl", this.preloaderUrl);

    this.$store.commit("setMoneda", this.monedaDefecto);
    this.$store.commit("setOrdenTarifa", this.ordenTarifa);
    this.$store.commit("setTarifaConector", this.tarifaConector);

    /** Circuito */
    this.$store.commit("setFichaCodigo", this.codigo);
    this.$store.commit("setFichaConector", this.conector);

    /** Disponibilidad por Conector */
    this.$store.commit("setParams", this.params);
    this.$store.dispatch("buscar");
  },
  mounted() {
    let width = this.$refs.filtrosCol.offsetWidth;
    width = width - 10;
    this.filtrosWidth = width + "px";
  },
  computed: {
    ...mapGetters(["isPreloader", "isMaster", "getTotal"]),
  },
  methods: {
    toggleFiltros() {
      this.showFiltros = !this.showFiltros;
    },
    toggleBuscador() {
      this.showBuscador = !this.showBuscador;
    },
    clear() {
      this.$refs.filtroAdmin.clear();
      this.$refs.filtroTexto.clear();
      this.$refs.filtroPrecio.clear();
      this.$refs.filtroSalidas.clear();
      this.$refs.filtroDuracion.clear();
      this.$refs.filtroDestinos.clear();
      this.$refs.filtroProveedores.clear();
      //this.$store.commit("clearFiltros");
    },
  },
};
</script>

<template>
  <div class="resultados_busqueda">
    <preloader-ficha></preloader-ficha>

    <div class="container">
      <div class="visible-xs visible-sm" id="botonera">
        <btn-group justified>
          <btn justified @click="toggleFiltros">Filtrar</btn>
          <btn
            justified
            @click="toggleBuscador"
            v-html="'Nueva B&uacute;squeda'"
          ></btn>
        </btn-group>
      </div>

      <aside
        :class="{
          null: showBuscador === null,
          slideInRight: showBuscador === true,
          slideOutRight: showBuscador === false,
        }"
        id="buscador"
      >
        <div class="visible-xs visible-sm aside-header">
          Nueva Busqueda
          <btn @click="toggleBuscador">
            <i class="mdi mdi-close-circle-outline"></i>
          </btn>
        </div>
        <buscador
          :url="url"
          :mes_salida="params.mes_salida"
          :ciudad_salida="params.ciudad_salida"
          :ciudades="params.ciudades"
          :proveedores="params.proveedores"
          :is-admin="isAdmin"
          :showConectores="showConectores"
        ></buscador>
      </aside>

      <preloader></preloader>

      <div class="row row-20">
        <div class="col-xs-12 col-sm-12 col-md-3" ref="filtrosCol">
          <aside
            id="filtros"
            :class="{
              null: showFiltros === null,
              slideInLeft: showFiltros === true,
              slideOutLeft: showFiltros === false,
            }"
          >
            <div class="visible-xs visible-sm aside-header">
              Filtrar
              <btn @click="toggleFiltros">
                <i class="mdi mdi-close-circle-outline"></i>
              </btn>
            </div>

            <total></total>

            <proveedores v-if="isDev"></proveedores>

            <filtro-texto ref="filtroTexto"></filtro-texto>
            <!-- <filtro-precio ref="filtroPrecio"></filtro-precio> -->
            <filtro-duracion ref="filtroDuracion"></filtro-duracion>
            <filtro-salidas
              ref="filtroSalidas"
              :default="params.ciudad_salida"
            ></filtro-salidas>
            <filtro-destinos ref="filtroDestinos"></filtro-destinos>
            <filtro-proveedores v-if="showConectores" ref="filtroProveedores"></filtro-proveedores>
            <filtro-admin
              ref="filtroAdmin"
              v-show="isAdmin || isDev"
            ></filtro-admin>
            <filtro-clear @clear="clear"></filtro-clear>
          </aside>
        </div>

        <div class="col-xs-12 col-sm-12 col-md-9">
          <barra></barra>
          <resultados @clear="clear"></resultados>
        </div>
      </div>

      <go-top-button
        :animate="true"
        :speed="50"
        :acceleration="2"
        :scrollDistance="300"
        classNames="btn btn-default btn-go-top"
      >
        <i class="mdi mdi-chevron-up"></i>
      </go-top-button>
    </div>
  </div>
</template>

<style lang="scss">
.resultados_busqueda {
  > .container {
    #botonera {
      margin-bottom: 20px;
    }

    aside {
      padding-bottom: 15px;
    }
  }
}

@media (max-width: 991px) {
  .resultados_busqueda {
    margin: 20px 0;

    > .container {
      .affix {
        top: inherit;
        position: relative;

        aside {
        }
      }

      aside {
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        width: auto !important;
        z-index: 999999999999;
        padding: 65px 25px 25px 25px;
        position: fixed;
        background: #273445;
        overflow-y: scroll;

        animation-duration: 1s;
        animation-fill-mode: both;

        &.null {
          display: none;
        }

        &.slideInLeft {
          animation-name: slideInLeft;
        }

        &.slideOutLeft {
          animation-name: slideOutLeft;
        }

        &.slideInRight {
          animation-name: slideInRight;
        }

        &.slideOutRight {
          animation-name: slideOutRight;
        }

        > .aside-header {
          top: 0;
          left: 0;
          right: 0;
          height: 44px;
          padding: 5px 80px 5px 25px;
          position: fixed;
          background: #0e141f;
          color: #fff;
          font-size: 20px;
          font-weight: 600;
          line-height: 30px;

          .btn {
            top: 6px;
            right: 25px;
            width: 36px;
            height: 32px;
            padding: 1px 6px;
            position: absolute;
            .mdi {
              font-size: 20px;
            }
          }
        }
      }
    }
  }
}

@media (min-width: 992px) {
  .resultados_busqueda {
    min-height: 100vh;
    > .container {
      .affix {
        z-index: 999;
        aside#filtros {
          padding: 0 10px 15px 0px;
          max-height: 100vh;
          overflow-y: auto;
          overflow-x: hidden;
        }
      }
    }
  }
}

@keyframes slideInLeft {
  0% {
    transform: translateX(-100%);
    visibility: visible;
  }
  100% {
    transform: translateX(0);
  }
}

@keyframes slideOutLeft {
  0% {
    transform: translateX(0);
  }
  100% {
    visibility: hidden;
    transform: translateX(-100%);
  }
}

@keyframes slideInRight {
  0% {
    transform: translateX(100%);
    visibility: visible;
  }
  100% {
    transform: translateX(0);
  }
}

@keyframes slideOutRight {
  0% {
    transform: translateX(0);
  }
  100% {
    visibility: hidden;

    transform: translateX(100%);
  }
}
</style>